import { Injectable, inject } from '@angular/core';
import { UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class CanAccessInstructorSearchGuard {
  private authService = inject(AuthenticationService);
  private router = inject(Router);

  public canActivateChild(): Observable<boolean | UrlTree> {
    return this.canActivate();
  }

  public canActivate(): Observable<boolean | UrlTree> {
    return this.authService.whenProfileReady$.pipe(
      switchMap(() => this.authService.canAccessInstructorSearch()),
      tap((canAccess) => {
        if (!canAccess) {
          this.authService.setUrlAfterLogin();
        }
      }),
      map((canAccess) => {
        if (!canAccess) {
          return this.router.parseUrl('/user/login');
        }

        return true;
      }),
    );
  }
}
